import { createAction } from "@reduxjs/toolkit";
import type { UpdatePreferencesResponse } from "@somewear/api";
import type { WorkspacePreferencesDto } from "@somewear/api/src/proto/workspace_preferences_proto_pb";
import { createActionSet } from "@somewear/model";

import type { WorkspacePreferencesRequestSchema } from "./workspacePreferences.model";

export const emitWorkspacePreferencesReceived = createAction<WorkspacePreferencesDto.AsObject>(
	"emitWorkspacePreferencesReceived",
);

export const workspacePreferencesActions = {
	updateWorkspacePreferences: createActionSet<
		WorkspacePreferencesRequestSchema,
		UpdatePreferencesResponse.AsObject
	>("workspace/preferences/update"),
};
